export default __webpack_public_path__ + "static/assembly_troubles-4d430d7385b95fd0c9cccee7baeb2ba6.jpg";